import React from 'react';
import {
  Container, Segment, Header, Icon,
} from 'semantic-ui-react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { errorMessage } from '@/utils/errors';

const ErrorPlaceHolder = ({ children, className, error }) => {
  const intl = useIntl();
  return (
    <Container className={clsx('aridhia-error-place-holder', className)}>
      <Segment placeholder raised className="aridhia-error-placeholder">
        <Header as="h2" icon textAlign="center">
          <Icon name="times circle" className="primary" circular />
          {errorMessage(error, intl)}
        </Header>
        {children}
      </Segment>
    </Container>
  );
};

export default ErrorPlaceHolder;
